import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { Headline } from '../../components/Headline/Headline.js';
import { useMobileMode } from '../../hooks/useMobileMode.js';
import { Img } from '../Img/Img.js';
export const NotFound = JSX(({ title, description }) => {
    const isMobileMode = useMobileMode();
    return (_jsxs("div", { className: "bg-white p-6xl py-20 flex gap-s flex-col @xl:items-center", children: [_jsx(Img, { image: { icon: 'MagnifierIcon', iconVersion: 'normal' }, width: "120", height: "120" }), _jsx(Headline, { title: title, description: description, headlineVersion: isMobileMode ? 'L' : 'S', isEmbedded: true, className: "space-y-s" })] }));
});
//# sourceMappingURL=NotFound.js.map